import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import './menuToggler.css';


const propTypes = {
  toggleMenu: PropTypes.func.isRequired,
  menuState: PropTypes.bool.isRequired,
};

class MenuToggler extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { menuState, toggleMenu } = this.props;

    toggleMenu(!menuState);
  }

  render() {
    return (
      <div className="sixteen wide mobile only tablet only column">
        <div className="ui inverted blue fixed mobile menu">
          <Link to="/" className="header item">
            <FormattedMessage
              id="shortTitle"
              description="App short title"
            />
          </Link>
          <a onClick={this.handleClick} className="right floated item">
            <i className="sidebar icon" />
            Menu
          </a>
        </div>
      </div>
    );
  }
}

MenuToggler.propTypes = propTypes;

export default MenuToggler;



/** WEBPACK FOOTER **
 ** ./src/components/layout/nav/menuToggler/MenuToggler.js
 **/